<p>reservation-summary-combine works!</p>
